import "core-js/modules/es.array.push.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = ["aria-label"];
const _hoisted_2 = ["aria-current", "onClick"];
const _hoisted_3 = {
  class: "mobile-tab-bar__label"
};
const _hoisted_4 = {
  key: 0,
  class: "mobile-tab-bar__center"
};
const _hoisted_5 = ["aria-label"];
const _hoisted_6 = {
  class: "mobile-tab-bar__fab-ring"
};
const _hoisted_7 = {
  class: "mobile-tab-bar__fab-inner"
};
const _hoisted_8 = ["aria-current", "onClick"];
const _hoisted_9 = {
  class: "mobile-tab-bar__label"
};
import { computed } from 'vue';
import { HomeFilled, Plus, Coin, UserFilled, Share } from '@element-plus/icons-vue';
import { useRoute, useRouter } from 'vue-router';
import { trackAnalyticsLog } from '@/utils/analytics-track';
export default {
  __name: 'MobileTabBar',
  props: {
    /** @deprecated 兼容旧调用；优先用 mineOpen */
    moreOpen: {
      type: Boolean,
      default: false
    },
    mineOpen: {
      type: Boolean,
      default: false
    },
    showCenterFab: {
      type: Boolean,
      default: true
    }
  },
  emits: ['open-more', 'open-mine', 'navigate', 'create'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const route = useRoute();
    const router = useRouter();
    const leftTabs = [{
      key: 'home',
      labelKey: 'nav.mobileTabHome',
      icon: HomeFilled,
      to: '/',
      match: path => path === '/'
    }, {
      key: 'referrals',
      labelKey: 'nav.invite',
      icon: Share,
      to: '/referrals',
      match: path => path.startsWith('/referrals')
    }];
    const rightTabs = [{
      key: 'crypto',
      labelKey: 'nav.crypto',
      icon: Coin,
      to: '/crypto',
      match: path => path === '/crypto' || path.startsWith('/crypto/')
    }, {
      key: 'mine',
      labelKey: 'nav.mobileTabMore',
      icon: UserFilled,
      match: () => props.mineOpen || props.moreOpen
    }];
    const isCreateActive = computed(() => route.path.startsWith('/create-market'));
    function isActive(tab) {
      if (typeof tab.match === 'function') {
        return tab.match(route.path);
      }
      return false;
    }
    function onTabClick(tab) {
      emit('navigate');
      if (tab.key === 'mine') {
        emit('open-mine');
        emit('open-more');
        return;
      }
      const channel = String(tab?.key || '').trim();
      if (channel) {
        trackAnalyticsLog({
          key: 'channel.switch',
          label: '频道切换',
          value: {
            channel,
            source: 'tabbar'
          }
        });
      }
      if (tab.to && route.path !== tab.to) {
        router.push(tab.to);
      }
    }
    function onCreateClick(event) {
      emit('navigate');
      emit('create', event);
    }
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      return _openBlock(), _createElementBlock("nav", {
        class: _normalizeClass(["mobile-tab-bar", {
          'mobile-tab-bar--no-fab': !__props.showCenterFab
        }]),
        "aria-label": _ctx.$t('nav.mobileTabNav')
      }, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(leftTabs, tab => {
        return _createElementVNode("button", {
          key: tab.key,
          type: "button",
          class: _normalizeClass(["mobile-tab-bar__item", {
            'is-active': isActive(tab)
          }]),
          "aria-current": isActive(tab) ? 'page' : undefined,
          onClick: $event => onTabClick(tab)
        }, [_createVNode(_component_el_icon, {
          class: "mobile-tab-bar__icon",
          "aria-hidden": "true"
        }, {
          default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(tab.icon)))]),
          _: 2
        }, 1024), _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t(tab.labelKey)), 1)], 10, _hoisted_2);
      }), 64)), __props.showCenterFab ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["mobile-tab-bar__fab", {
          'is-active': isCreateActive.value
        }]),
        "aria-label": _ctx.$t('nav.createMarket'),
        onClick: onCreateClick
      }, [_createElementVNode("span", _hoisted_6, [_createElementVNode("span", _hoisted_7, [_createVNode(_component_el_icon, {
        class: "mobile-tab-bar__fab-icon"
      }, {
        default: _withCtx(() => [_createVNode(_unref(Plus))]),
        _: 1
      })])])], 10, _hoisted_5)])) : _createCommentVNode("", true), (_openBlock(), _createElementBlock(_Fragment, null, _renderList(rightTabs, tab => {
        return _createElementVNode("button", {
          key: tab.key,
          type: "button",
          class: _normalizeClass(["mobile-tab-bar__item", {
            'is-active': isActive(tab)
          }]),
          "aria-current": isActive(tab) ? 'page' : undefined,
          onClick: $event => onTabClick(tab)
        }, [_createVNode(_component_el_icon, {
          class: "mobile-tab-bar__icon",
          "aria-hidden": "true"
        }, {
          default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(tab.icon)))]),
          _: 2
        }, 1024), _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t(tab.labelKey)), 1)], 10, _hoisted_8);
      }), 64))], 10, _hoisted_1);
    };
  }
};